'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Button, Heading, LayoutCluster, useIsMounted } from 'design-system/client';
import { useTranslations } from 'next-intl';
import HolderTitle from '../HolderTitle';
import styles from './HolderHeadline.module.css';
import { useDonationFormContext, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
function HolderHeadline() {
  const $ = _c(20);
  const t = useTranslations("nextjs.donate.donor_headline");
  const {
    setValue
  } = useDonationFormContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["_company_donation"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [companyDonation] = useDonationFormValues(t0);
  let t1;
  if ($[1] !== companyDonation || $[2] !== t) {
    t1 = companyDonation ? <Heading level="heading-xs">{t("company")}</Heading> : <HolderTitle />;
    $[1] = companyDonation;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const headline = t1;
  const disabled = !useIsMounted();
  let t2;
  if ($[4] !== companyDonation || $[5] !== t) {
    t2 = companyDonation ? t("switch_to_personal") : t("switch_to_company");
    $[4] = companyDonation;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const switchLabel = t2;
  let t3;
  if ($[7] !== headline) {
    t3 = <div className="donations-form-holder-label">{headline}</div>;
    $[7] = headline;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classNames(styles.link, "colorOverride");
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== companyDonation || $[11] !== disabled || $[12] !== setValue) {
    t5 = evt => {
      if (disabled) {
        return evt.preventDefault();
      }
      setValue("_company_donation", !companyDonation);
    };
    $[10] = companyDonation;
    $[11] = disabled;
    $[12] = setValue;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== switchLabel || $[15] !== t5) {
    t6 = <div className={styles.linkWrapper}><Button kind="plain" size="small" className={t4} type="button" onClick={t5} data-axe-expect="color-contrast">{switchLabel}</Button></div>;
    $[14] = switchLabel;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t6) {
    t7 = <LayoutCluster>{t3}{t6}</LayoutCluster>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
export default HolderHeadline;